export const titleHeader = 'トライアル';

/** スナックバーの自動非表示時間（ミリ秒）：短め（保存完了など即時フィードバック向け） */
export const SNACKBAR_AUTO_HIDE_DURATION_SHORT = 3000;

/** スナックバーの自動非表示時間（ミリ秒）：標準（情報通知向け） */
export const SNACKBAR_AUTO_HIDE_DURATION = 6000;
